<template>
  <v-container fluid grid-list-md py1>
    <v-layout row wrap>
      <v-flex md4>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.operativos.statusPreContacto.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <!-- Clave -->
                  <v-text-field v-if="statusPreContacto.clave" v-model="statusPreContacto.clave" :label="$t('view.commons.clave')" disabled />

                  <!-- Descripcion -->
                  <v-text-field
                    v-model.trim="$v.statusPreContacto.descripcion.$model"
                    :label="$t('view.operativos.statusPreContacto.form.descripcion.label')"
                    :error-messages="getFirstErrorDescription($v.statusPreContacto.descripcion)"
                    maxlength="255"
                    :disabled="view.action.submit.busy"
                    onkeypress="return /^[a-zA-Z0-9\r\.\+\-\_\ ]+$/.test(event.key);" />

                  <!-- Estatus -->
                  <label for="status" class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                  <v-switch v-model="statusPreContacto.status" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                </form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-show="statusPreContacto.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="$userPermission.hasPermission('ROLE_MODIFICAR_OP')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>

      <v-flex md8>
        <data-table ref="statusPreContactoTable" @editRow="load" @auditRow="audit" />
      </v-flex>
    </v-layout>
    <auditoria ref="auditModal" />
  </v-container>
</template>
<script>
import statusPreContactoStates from "@/views/operativos/statusPreContacto/statusPreContacto-state"; /** *******************************/
import statusPreContactoAPI from "@/services/operativos/statusPreContacto"; /** *******************************/
import DataTable from "@/views/operativos/statusPreContacto/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required } from "vuelidate/lib/validators";
import { fixMigImp } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { submit } from "@/constants/buttons";
import tippy from "tippy.js";

const action = { submit: { busy: false } };

export default {
  name: "StatusPreContactoModule"
  , components: {
    DataTable
    , Auditoria
  }
  , data() {
    return {
      statusPreContacto: undefined
      , form: new Object()
      , view: {
        title: this.$t("view.operativos.statusPreContacto.title")
        , action
        , elem: {
          button: { submit }
          , showForm: true
        }
      }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.form = new statusPreContactoStates(this);
    this.form.$setState("initial");
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.statusPreContacto);
        handleResponse(respuesta, this.$t("view.operativos.statusPreContacto.errors"));
      } catch (error) {
        handleResponse(error, this.$t("view.operativos.statusPreContacto.errors"));
      }
    }
    , async load(clave) {
      try {
        const response = await statusPreContactoAPI.get(clave);
        const { data: { results: { statusPreContacto } } } = response;
        this.form.$setState("editing", statusPreContacto);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.statusPreContacto.clave, dataDescripcion = this.statusPreContacto.descripcion) {
      this.$refs.auditModal.loadAudit(clave, "TStatusPreContacto", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
  }
  , validations: { statusPreContacto: { descripcion: { required, fixMigImp: fixMigImp() } } }
};
</script>



// WEBPACK FOOTER //
// src/views/operativos/statusPreContacto/StatusPreContacto.vue